import React from 'react'
import { useParams } from 'react-router-dom'
import { PageHeader } from '@lmc/ui-kit'
import { useTranslation } from 'react-i18next'
import { NAMESPACE } from 'locale'
import { transferRecordConstants as trConstants } from 'locale/transferRecords'
import { TransferRecordList } from './components/TransferRecordList'
import { useTransferRecordsList } from './hooks/useTransferRecordsList'
import useResident from 'hooks/useResident'

export const ResidentTransferRecordsScreen: React.FC = () => {
  const { t } = useTranslation(NAMESPACE.TRANSFER_RECORDS)
  const { id: residentId } = useParams<{ id: string }>()

  const { resident } = useResident({ id: residentId })
  const residentName = resident?.name
    ? `${resident.name.first} ${resident.name.last}`
    : ''

  const { records, isLoading, fetchNextPage, hasNextPage, isFetchingNextPage } =
    useTransferRecordsList({
      residentId: residentId || ''
    })

  return (
    <>
      <PageHeader
        title={t(trConstants.TRANSFER_AND_HOSPITALISATION_RECORDS, {
          name: residentName
        })}
        help={{
          content: t(trConstants.TRANSFER_RECORDS_TOOLTIP)
        }}
        sticky
      />

      <TransferRecordList
        records={records}
        isLoading={isLoading}
        fetchNextPage={fetchNextPage}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
      />
    </>
  )
}
